"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newResetPasswordTokenInvalidError = exports.newValidationFailedError = exports.newCaptchaRequiredError = exports.newLoginInvalidError = exports.newApiError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectPath = _interopRequireDefault(require("object-path"));

var newApiError = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(request, response) {
    var responseData, displayMessage, apiError;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return response.json();

          case 3:
            responseData = _context.sent;
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

          case 8:
            displayMessage = _objectPath["default"].get(responseData, "msg");
            apiError = new Error("Request to \"".concat(request.method, " ").concat(request.path, "\" failed with status ").concat(response.status));
            apiError.type = "API";
            apiError.status = response.status;
            apiError.displayMessage = displayMessage;
            apiError.responseData = responseData || {};
            apiError.request = request;
            apiError.response = response;
            return _context.abrupt("return", apiError);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));

  return function newApiError(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.newApiError = newApiError;

var newLoginInvalidError = function newLoginInvalidError(parentError) {
  var loginInvalidError = new Error();
  loginInvalidError.type = "LOGIN_INVALID";
  loginInvalidError.displayMessage = parentError.displayMessage;
  return loginInvalidError;
};

exports.newLoginInvalidError = newLoginInvalidError;

var newCaptchaRequiredError = function newCaptchaRequiredError(parentError) {
  var _parentError$response, _parentError$response2;

  var captchaRequiredError = new Error();
  captchaRequiredError.type = "CAPTCHA_REQUIRED";
  captchaRequiredError.displayMessage = parentError.displayMessage ? parentError.displayMessage : parentError === null || parentError === void 0 ? void 0 : (_parentError$response = parentError.responseData) === null || _parentError$response === void 0 ? void 0 : _parentError$response.msg;
  captchaRequiredError.captchaSiteKey = parentError === null || parentError === void 0 ? void 0 : (_parentError$response2 = parentError.responseData) === null || _parentError$response2 === void 0 ? void 0 : _parentError$response2.captchaSiteKey;
  captchaRequiredError.path = parentError.path;
  return captchaRequiredError;
};

exports.newCaptchaRequiredError = newCaptchaRequiredError;

var newValidationFailedError = function newValidationFailedError(parentError) {
  var validationFailedError = new Error();
  validationFailedError.type = "VALIDATION_FAILED";
  validationFailedError.displayMessage = parentError.displayMessage;
  validationFailedError.errors = _objectPath["default"].get(parentError, ["responseData", "data"], {});
  return validationFailedError;
};

exports.newValidationFailedError = newValidationFailedError;

var newResetPasswordTokenInvalidError = function newResetPasswordTokenInvalidError(parentError) {
  var resetPasswordTokenInvalidError = new Error();
  resetPasswordTokenInvalidError.type = "RESET_PASSWORD_TOKEN_INVALID";
  resetPasswordTokenInvalidError.title = parentError.title;
  resetPasswordTokenInvalidError.displayMessage = parentError.displayMessage;
  return resetPasswordTokenInvalidError;
};

exports.newResetPasswordTokenInvalidError = newResetPasswordTokenInvalidError;